// src/components/Results/SupplementResultCard.js
import React from 'react';
import './SupplementResultCard.css';

const SupplementResultCard = ({ supplement }) => {
  return (
    <div className="result-card">
      <a href={supplement.amazonAffiliateLink} target="_blank" rel="noopener noreferrer sponsored" className="card-link-wrapper">
        <div className="card-image-container">
          <img src={supplement.imageUrl} alt={supplement.name} className="card-image" />
        </div>
        <div className="card-content">
          <p className="card-brand">{supplement.brand}</p>
          <h4 className="card-name">{supplement.name}</h4>
        </div>
      </a>
    </div>
  );
};

export default SupplementResultCard;
